export const iconFontAwesomeArrowsReplyAll = (
	<i className="fa-solid fa-reply-all"></i>
);
